import { useTranslation } from '@flecto/translations/src'
import { Badge } from '@flecto/ui/src'

export function BadgeInsurancePolicy({ policyType }: { policyType: string }) {
  const { t } = useTranslation('saas', { keyPrefix: 'insurances' })

  if (!policyType) return

  const insurancePolicyType = {
    label: '',
  }

  switch (policyType) {
    case 'regular':
      insurancePolicyType.label = t('policy_type.regular')
      break

    case 'early_pickup':
      insurancePolicyType.label = t('policy_type.early_pickup')
      break

    case 'extension':
      insurancePolicyType.label = t('policy_type.extension')
      break
  }

  return <Badge color='gray.7'>{insurancePolicyType.label}</Badge>
}
